import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-20" }
const _hoisted_2 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormOutlined = _resolveComponent("FormOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_link_outlined = _resolveComponent("link-outlined")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: _ctx.$t('screenTitle.articleList')
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_link, {
          to: { name: _ctx.RouteName.ARTICLES_NEW }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, { type: "primary" }, {
              icon: _withCtx(() => [
                _createVNode(_component_FormOutlined)
              ]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString(_ctx.$t('screenTitle.articleNew')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createVNode(_component_a_table, {
        dataSource: _ctx.dataSource,
        columns: _ctx.columns,
        pagination: _ctx.pagination,
        loading: _ctx.isLoading
      }, {
        bodyCell: _withCtx(({ column, record }) => [
          (column.key === 'action')
            ? (_openBlock(), _createBlock(_component_a_space, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, {
                    to: { name: _ctx.RouteName.ARTICLES_DETAIL, params: { article_id: record.id } }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, { type: "primary" }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_FormOutlined)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createElementVNode("a", {
                    href: _ctx.getArticleViewUrl(record),
                    target: "_blank"
                  }, [
                    _createVNode(_component_a_button, { type: "primary" }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_link_outlined)
                      ]),
                      _: 1
                    })
                  ], 8, _hoisted_2),
                  _createVNode(_component_a_button, {
                    type: "primary",
                    danger: "",
                    onClick: ($event: any) => (_ctx.deleteConfirm(record))
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_DeleteOutlined)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["dataSource", "columns", "pagination", "loading"])
    ]),
    _: 1
  }, 8, ["title"]))
}